(function () {
  function apply() {
    var el = document.querySelector('.footer__copyright');
    if (el) {
      el.innerHTML = '<span class="copyright__content">&copy; 2009-2026 PRINT IDEEA SRL, RO26275960. All Rights Reserved</span>';
      return true;
    }
    return false;
  }
  if (!apply()) {
    var obs = new MutationObserver(function () {
      if (apply()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 10000);
  }
})();